import { api } from '../../core/api.js';
import { dashboardSourceId } from '../../core/parity.js';
import { readDashboardV2 } from '../../core/flags.js';

function productQuery(productId) {
  return productId ? `?product_id=${encodeURIComponent(productId)}` : '';
}

/**
 * Each card has its own request so one failure does not blank the page.
 * Product KPIs (MAU, activation, retention) come from /insights; /kpi/dashboard
 * is the tenant rollup and does not carry those series.
 * When DASHBOARD_V2 is on, also fetches `/dashboard/v2`.
 * @param {string} productId
 * @param {{ me?: object }} [opts]
 */
export function loadDashboard(productId, opts = {}) {
  const query = productQuery(productId);
  const wantV2 = readDashboardV2(opts.me);
  return Promise.all([
    api('/kpi/dashboard'),
    productId ? api(`/insights${query}`) : Promise.resolve({ error: 'Select a product', status: 400 }),
    productId ? api(`/connectors/depth${query}`) : Promise.resolve({ analysis_depth: 0, depth_breakdown: {} }),
    productId ? api(`/schedules${query}`) : Promise.resolve({ error: 'Select a product', status: 400 }),
    productId ? api(`/connectors${query}`) : Promise.resolve({ integrations: [] }),
    productId ? api(`/chat${query}`) : Promise.resolve({ groups: [] }),
    wantV2 && productId
      ? api(`/dashboard/v2${query}`)
      : Promise.resolve(null),
  ]).then(([kpi, insights, depth, schedules, connectors, chats, v2]) => {
    const data = { kpi, insights, depth, schedules, connectors, chats, v2: null };
    data.source_id = dashboardSourceId(data);
    if (v2 && !v2.error) data.v2 = v2;
    data.dashboard_v2 = !!(wantV2 && data.v2);
    return data;
  });
}
